// extracted by mini-css-extract-plugin
export default {"form":"SendCoins_form__mOj8S"};